import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { COMPANY } from "@/data/siteData";

export const CtaBand = () => (
  <section data-testid="cta-band" className="mx-auto max-w-7xl px-6 pb-24 lg:px-10 lg:pb-32">
    <Reveal>
      <div className="flex flex-col gap-8 rounded-3xl border border-border bg-secondary p-10 lg:flex-row lg:items-center lg:justify-between lg:p-16">
        <div className="max-w-xl">
          <p className="eyebrow text-primary">Start with an evaluation</p>
          <h2 className="mt-4 font-display text-3xl font-light leading-tight text-foreground sm:text-4xl">
            Tell us what your system needs. We&rsquo;ll scope it honestly.
          </h2>
          <p className="mt-4 text-base font-light text-muted-foreground">
            Submit a service inquiry and the {COMPANY.name} team will review your details and respond with a clear next step
            &mdash; no pressure, no upsell.
          </p>
        </div>
        <div className="flex flex-wrap gap-4">
          <Link to="/contact" data-testid="cta-band-contact" className="inline-flex items-center gap-2 rounded-full bg-primary px-7 py-3.5 text-sm font-medium text-white transition-[transform,box-shadow] duration-200 hover:-translate-y-0.5 hover:shadow-lg">
            Submit an Inquiry <ArrowRight className="h-4 w-4" />
          </Link>
          <a href={COMPANY.bbbUrl} target="_blank" rel="noopener noreferrer" data-testid="cta-band-bbb" className="inline-flex items-center gap-2 rounded-full border border-primary/30 px-7 py-3.5 text-sm font-medium text-primary transition-colors duration-200 hover:bg-primary/5">
            <ShieldCheck className="h-4 w-4" /> Verify us on BBB
          </a>
        </div>
      </div>
    </Reveal>
  </section>
);
